import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import buttons from './buttons';
import PositionsTable from '@components/PositionsTable/PositionsTable';
import { setEditorVerticesType } from '../../../reducers/selectors/editor/actions';
import { setPanelOptions, setPanelWidth, setPanelHeight, setPanelSideLength } from '../../../reducers/options/panel/actions';
import { GeneralCalculationState } from '../../../reducers/options/panel/defaults/generalCalculation';

import Input from '@components/Input';
import { unitLabel, unitTransform } from '@services/helper.service';
import { defaultUnits } from '@config';
import Panel from '@scene/objects/panel';
import * as THREE from 'three';
import { APP_TEXTS } from '@texts';
import {getTooltip, APP_TOOLTIPS } from '../../../texts/tooltips';
import { Tooltip } from '@components/Tippy';
import Scene  from '@scene';

// eslint-disable-next-line react/prefer-stateless-function
class Plate extends Component {

  static propTypes = {
    onUpdate: PropTypes.func.isRequired,
    positions: PropTypes.array.isRequired
  };

  render() {
    return (
      <div className="list-type">
        <h4>{APP_TEXTS.LABEL_PLATE_STANDARD_SHAPES.Content}</h4>

        <ul className="inline-list mb-2">
          {buttons.map(button => (

                <Tooltip  key={button.id}  content={getTooltip(button.tooltip)}>        
            <li key={button.id}>
              <button
                className={`btn btn-light ${button.config.custom.type === this.props.type && "ImageButton--active"}`}
                onClick={() => {
                  this.props.onUpdate(button.config);
                }}
              >
                <span className={button.icon} />
              </button>
            </li>
            </Tooltip>
          ))}
        </ul>

        {(this.props.type === 1 || this.props.type === 2) ? (
          <React.Fragment>
            <div className="input-group mb-2 w-50">
              <div className="input-group-prepend">
                <span className="input-group-text">Lx</span>
              </div>
              <Tooltip content={APP_TOOLTIPS.TOOLTIP_BASE_PLATE_LX.Content}>
              <Input
                id="lx-input"
                type="number"
                postfix={unitLabel(this.props.unit)}
                placeholder="Lx"
                min="1"
                value={unitTransform(this.props.panelWidth)
                  .from(defaultUnits.DISTANCE)
                  .to(this.props.unit)}
                onUpdate={value => {
                  this.props.setWidth(
                    unitTransform(+value)
                      .from(this.props.unit)
                      .to(defaultUnits.DISTANCE)
                  );
                }}
              />
              </Tooltip>
            </div>
            
            <div className="input-group mb-2 w-50">
              <div className="input-group-prepend">
                <span className="input-group-text">Ly</span>
              </div>
              <Tooltip content={APP_TOOLTIPS.TOOLTIP_BASE_PLATE_LY.Content}>
              <Input
                id="ly-input"
                type="number"
                postfix={unitLabel(this.props.unit)}
                placeholder="Ly"
                min="1"
                value={unitTransform(this.props.panelHeight)
                  .from(defaultUnits.DISTANCE)
                  .to(this.props.unit)}
                onUpdate={value => {
                  this.props.setHeight(
                    unitTransform(+value)
                      .from(this.props.unit)
                      .to(defaultUnits.DISTANCE)
                  );
                }}
              />
              </Tooltip>
            </div>
          </React.Fragment>
        ) : (this.props.type === 3 ? ( 
          <div className="input-group mb-2 w-50">
            <div className="input-group-prepend">
              <span className="input-group-text">{APP_TEXTS.LABEL_BUTTONS_CUSTOM_R.Content}</span>
            </div>
            <Tooltip content={APP_TOOLTIPS.TOOLTIP_BASE_PLATE_RADIUS.Content}>
            <Input
              id="r-input"
              type="number"
              postfix={unitLabel(this.props.unit)}
              placeholder="R"
              min="1"
              value={unitTransform(this.props.panelWidth/2)
                .from(defaultUnits.DISTANCE)
                .to(this.props.unit)}
              onUpdate={value => {
                this.props.setRadius(
                  unitTransform(+value)
                    .from(this.props.unit)
                    .to(defaultUnits.DISTANCE)
                );
              }}
            />
            </Tooltip>
          </div>
        ) : (
          <div className="input-group mb-2 w-50">
            <div className="input-group-prepend">
              <span className="input-group-text">{APP_TEXTS.LABEL_PLATE_SIDE.Content}</span>
            </div>
            <Tooltip content={APP_TOOLTIPS.TOOLTIP_BASE_PLATE_SIDE.Content}>
            <Input
              id="lx-input"
              type="number"
              postfix={unitLabel(this.props.unit)}
              placeholder={APP_TEXTS.LABEL_PLATE_SIDE.Content} //"Side"
              min="1"
              value={unitTransform(this.props.panelSide)
                .from(defaultUnits.DISTANCE)
                .to(this.props.unit)}
              onUpdate={value => {
                this.props.setSideLength(
                  unitTransform(+value)
                    .from(this.props.unit)
                    .to(defaultUnits.DISTANCE),
                  buttons.find(btn => {return btn.config.custom.type === this.props.type;}).config.panel.vertices.count
                );
              }}
            />
            </Tooltip>
          </div>
        ))}

        <PositionsTable positions={this.props.positions} onUpdate={this.props.onUpdate} invert />
      </div>
    );
  }

}

const mapState = state => ({
  type: state.selectors.editor.vertices.type,
  positions: state.options.panel.vertices.positions.map(pos => new THREE.Vector3(pos.x, pos.y * -1, pos.z)),
  panelWidth: state.options.panel.width,
  panelHeight: state.options.panel.height,
  panelSide: state.options.panel.sideLength,
  unit: state.main.units.distance
});

const mapDispatch = dispatch => ({
  setRadius: value => dispatch(setPanelWidth(value * 2)),
  setWidth: value => dispatch(setPanelWidth(value)),
  setHeight: value => dispatch(setPanelHeight(value)),
  setSideLength: (sideLength, vertices) => {
    dispatch(setPanelSideLength(sideLength));
    dispatch(setPanelOptions({
      vertices: {
        count: vertices
      }
    }));
  },
  onUpdate: value => {
    if (value.custom.type) {
      dispatch(setEditorVerticesType(value.custom.type));
      setTimeout(() => Scene.resetCamera());
    }

    if (value.panel) {
      const defaultWidth = GeneralCalculationState.width;
      const defaultHeight = GeneralCalculationState.height;
      const defaultSideLength = GeneralCalculationState.sideLength;

      dispatch(
        setPanelOptions({
          width: defaultWidth,
          height: defaultHeight,
          sideLength: defaultSideLength,
          ...value.panel,
          vertices: {
            ...value.panel.vertices,
            positions: []
          }
        })
      );
    }

    if (value.custom.positions) {
      dispatch(
        setPanelOptions({
          type: Panel.types.CUSTOM,
          vertices: {
            count: 0,
            positions: value.custom.positions.map(pos => new THREE.Vector3(pos.x, pos.y * -1, pos.z))
          }
        })
      );
    }
  }
});

export default connect(
  mapState,
  mapDispatch
)(Plate);



// WEBPACK FOOTER //
// ./src/components/Editor/Plate/index.js